exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Login */\n.login-container {\n\tmargin-top: 120px;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-pack: center;\n\t    justify-content: center;\n\t-ms-flex-line-pack: center;\n\t    align-content: center;\n}\n\n.login-card {\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-direction: column;\n\t    flex-direction: column;\n\twidth: 300px;\n\tpadding: 2%;\n\tborder: solid 1px;\n\ttext-align: center;\n}\n\n.form-item {\n\tpadding: 5px;\n    margin-bottom: 2rem;\n    height: 30px;\n    width: 100%;\n    border: 1px solid grey;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/app/pages/Login.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/app/pages/Login.css
// module chunks = 0